import { createSelector } from 'reselect';

import {
  getMainSiteUrl,
  getBisLoginUrl,
  getCurrentAccountCtn,
} from 'store/common/header/selectors';

import { getWidgetsData } from '../../selectors';

const getThreeFoursData = (state) => getWidgetsData(state).threeFours || {};

// const getThreeFoursData = () => ({
//   frameBanner: {
//     background: '#fff 50% no-repeat',
//     backgroundImage: 'https://static.beeline.ru/upload/images/e-shop/treefours/threefours-desktop.jpg',
//     mobileBackground: '#fff',
//     mobileBackgroundImage: 'https://static.beeline.ru/upload/images/e-shop/treefours/threefours-mobile.jpg',
//     position: 0,
//   },
//   title: 'Ваша персональная скидка на iPhone, Samsung, Nokia, Xiaomi ждет вас!',
//   description: 'Ваш номер телефона - это ваш промокод',
//   numberFormDescription: 'Введите номер телефона, чтобы получить доступ к персональным скидкам',
//   smsFormDescription: 'На ваш телефон отправлено SMS с паролем для авторизации. ',
//   smsCaptchaFormDescription: 'Какое-то описание того, что ' +
//   'нашему любимому пользователю код в смс отправится только после ввода капчи.',
//   numberButton: 'К скидкам',
//   smsCodeButton: 'К скидкам',
//   captchaButton: 'Отправить код',
//   authButton: 'К покупке',
//   redirectUrl: '/shop/catalog/actions/personalnyi-kod/',
//   offerUrl: '/customers/products/mobile/bonus/details/tvoy-nomer-telefona-tvoy-promokod-na-skidku/',
//   offerUrlTitle: 'Подробнее об акции',
//   background: '#6657a0 right / auto 100% no-repeat',
//   backgroundImage: 'https://static.beeline.ru/upload/images/e-shop/treefours/back_shop_horizontal15.jpg',
//   mobileBackground: '#6657a0 center / cover no-repeat',
//   mobileBackgroundImage: 'https://static.beeline.ru/upload/images/e-shop/treefours/444-banner-mobile15.jpg',
//   isLightTheme: true,
//   errorTexts: {
//     smsCodeError: 'За сегодня вы исчерпали лимит SMS-кодов. Попробуйте завтра',
//     otherError: 'Что-то пошло не так или указанный номер не принадлежит «Билайн». ' +
//     '<a href="https://beeline.ru/mnp">Перейти в «Билайн» со своим номером. </a>',
//   },
// });

export const getThreeFoursAvailability = (state) => !!getWidgetsData(state).threeFours;

// export const getThreeFoursAvailability = () => true;

/**
 * This approach is not recommended, but since AuthForm
 * is a black box that takes a number of arguments,
 * creating single field selectors would only make things complicated
 */
export const getThreeFoursAuthFormData = createSelector(
  getThreeFoursData,
  getMainSiteUrl,
  getBisLoginUrl,
  getCurrentAccountCtn,
  (threeFoursData, mainSiteUrl, bisUrl, ctn) => ({
    ...threeFoursData,
    mainSiteUrl,
    bisUrl,
    ctn,
    isAuthenticated: !!ctn,
  }),
);

export const getThreeFoursOfferUrl = (state) => getThreeFoursData(state).offerUrl;
export const getThreeFoursOfferUrlTitle = (state) => getThreeFoursData(state).offerUrlTitle;
export const getThreeFoursRedirectUrl = (state) => getThreeFoursData(state).redirectUrl;
export const getThreeFoursIsLightTheme = (state) => getThreeFoursData(state).isLightTheme;
export const getThreeFoursPreAuthButtonText = (state) => getThreeFoursData(state).preAuthButton;

export const getThreeFoursCatalogBackgrounds = createSelector(
  getThreeFoursData,
  ({ background, backgroundImage, mobileBackground, mobileBackgroundImage }) => ({
    backgroundImage,
    background,
    mobileBackgroundImage,
    mobileBackground,
  }),
);

/**
 * local state selectors
 */
export const getThreeFoursModalIsOpen = (state) => getThreeFoursData(state).isModalOpen || false;

/**
 * local state selectors
 */
export const getFrameBanner = (state) => getThreeFoursData(state).frameBanner || {};
export const getFrameBannerPosition = (state) => getFrameBanner(state).position || 0;
export const getFrameBannerBackground = (state) => getFrameBanner(state).background || '';
export const getFrameBannerBackgroundImage = (state) => getFrameBanner(state).backgroundImage || '';
export const getFrameBannerMobileBackground = (state) =>
  getFrameBanner(state).mobileBackground || '';
export const getFrameBannerMobileBackgroundImage = (state) =>
  getFrameBanner(state).mobileBackgroundImage || '';
